import { defineTokens } from "@chakra-ui/react";

export const lineHeights = defineTokens.lineHeights({
  shorter: {
    value: 1.1,
  },
  short: {
    value: 1.3,
  },
  moderate: {
    value: 1.5,
  },
  tall: {
    value: 1.7,
  },
  taller: {
    value: 2,
  },
});
